











 








const node = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ActivityGrid_user",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ActivityCardFavorite_user"
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node ).hash = "4a1b8b9b257f7b937237e9a9d0d216c3";

export default node;
